// var $ = require('jquery')
import { imageCenter } from './imageCenter'
// import { func } from './func'

const ENV = window.ENV || {}

const _isLandscape = () => {
  return ENV.ORIENTATION === ENV.LANDSCAPE
}

const _isPortrait = () => {
  return ENV.ORIENTATION === ENV.PORTRAIT
}

ENV.LANDSCAPE = 'LANDSCAPE'
ENV.PORTRAIT = 'PORTRAIT'
ENV.HTML = $('html')
ENV.BODY = $('body')
ENV.DOC = $(document)
ENV.WIN = $(window)
ENV.ORIENTATION
ENV.IS_LANDSCAPE = _isLandscape()
ENV.IS_PORTRAIT = _isPortrait()

window.ENV = ENV

// Transition event
const whichTransitionEvent = function () {
  let t
  const el = document.createElement('fakeelement')

  const transitions = {
    'transition': 'transitionend',
    'OTransition': 'oTransitionEnd',
    'MozTransition': 'transitionend',
    'WebkitTransition': 'webkitTransitionEnd'
  }

  for (t in transitions) {
    if (el.style[t] !== undefined) {
      return transitions[t]
    }
  }
}

let transitionEvent = whichTransitionEvent()

// Module Variables
const _vars = {
  isOpen: false,
  sideDrawIsOpen: false,
  scrollPos: 0,
  scrollOffsetApplied: false,
  navTimer: null,
  disabledHandle: null,
  keyHandle: null,
  backdrop: null,
  animate: 'fade'
}

// Root elements for caching.
const _selectors = {
  nav: '.c-navigation',
  primaryNav: '.c-nav-primary',
  leftNav: '.js-left-nav',
  rightNav: '.js-right-nav',
  menuBtn: '#js-menu-btn',
  wrap: '#wrap',
  closeBtn: '#shenyun-nav__closeMenu',
  modalBackdrop: '.modal-backdrop-for-header',
  languageBtn: '.language-label'
}
// var $el = _selectors

// Module init
var _init = function (options) {
  if ($('.c-navigation').length) {
    $.extend(_options, options)

    // Define & Cache Elements
    _setElements()

    _bindEvents()

    // SET UP MENU BUTTON
    LANGUAGE_BUTTON.init()
  }
}
// Public functions
const _detectMenuStatus = function () {
  if (_vars.isOpen) {
    _close()
  } else {
    _open()
  }
}
export function _detectToClosedMenu () {
  if (_vars.isOpen) {
    _close()
  }
}

// Private functions

const _bindEvents = function () {
  // Prevent bubbling
  $el.primaryNav.find('> li').on(transitionEvent, function (e) {
    e.stopPropagation()
  })
  // var trigger = $el.menuBtn || $el.closeBtn

  // Main navigation
  $el.menuBtn.on('click', function (e) {
    e.preventDefault()

    _detectMenuStatus()
  })
  $el.closeBtn.on('click', function (e) {
    e.preventDefault()

    if (_vars.isOpen) {
      _close()
    }
  })
  // _vars.backdrop.on('click', function (e) {
  //   e.preventDefault()

  //   if (_vars.isOpen) {
  //     _close()
  //   }
  // })

  $el.rightNav.find('#menu-language-btn').on(transitionEvent, function (e) {
    _animComplete()
  // var isEL = $(e.target).hasClass('last-child')
  // if (isEL) {
  //   _animComplete()
  // }
  })
}

const _animComplete = () => {
  // console.log('transEnd')
  // console.log('is open')
  // console.log(_vars.isOpen)

  ENV.BODY.removeClass('side_draw_closing')

  if (_vars.isOpen) {
    ENV.HTML.addClass('nav-open-complete-html')
    ENV.BODY.addClass('nav-open-complete')
    $el.menuBtn.addClass('toggled')
  } else {
    ENV.HTML.removeClass('nav-open-complete-html')
    ENV.BODY.removeClass('nav-open-complete')
    ENV.BODY.removeClass('nav-close')

    // Remove faux scroll offset and restore real offset
    $el.wrap.attr('style', '')
    window.scrollTo(0, _vars.scrollPos)
    _vars.scrollOffsetApplied = false
  }
}

const _imgCenter = function () {
  const imageWrapList = document.querySelectorAll('.img-center')
  imageCenter(imageWrapList, 'wspectFill')
}

const _ajaxAction = function (elem) {
  return new Promise(function (resolve, reject) {
    if ($(elem).children().length == 0) {
      $.ajax({
        url: '/index/whats-new',
        type: 'GET',
        dataType: 'html',
        cache: false,
        timeout: 60000,
        success: function (data, textStatus, xhr) {
          $(elem).html(data)
          resolve()
        },
        error: function (jqXHR, textStatus, errorThrown) {
          if (textStatus === 'timeout') {
          } else {
          }
        }
      })
    } else reject()
  }).then(function () {
    _imgCenter()
  }, function () {
    console.log('reject()')
  })
}

const _open = function () {
  _vars.isOpen = true

  // Check for visible image elements and lazyload
  // setTimeout(() => {
  //     LAZY_IMG.initialiseLazyBgImgs()
  // }, 500)

  // if($target.attr("aria-hidden") === false) return false

  // Apply ARIA
  $el.nav.attr('aria-hidden', false)

  _ajaxAction('#shenyun-nav-category-whats-new')

  // If larger than tablet, make the nav the same height as the right nav
  // if ($(window).width() > 768) $el.nav.css({
  //     'height': $el.rightNav.height()
  // })

  // Save scroll position
  if (!_vars.scrollOffsetApplied) _vars.scrollPos = window.pageYOffset

  // UPDATE MENU BUTTON
  $el.menuBtn.attr('aria-expanded', true)
  // $el.menuBtn.addClass('toggled')

  // Send state to Snap.svg
  // MENU_BUTTON.change(_vars.isOpen)

  var offset = -_vars.scrollPos

  _vars.navTimer = setTimeout(function () {
    clearTimeout(_vars.navTimer)

    if (!_vars.scrollOffsetApplied) {
      $el.wrap.css({
        'top': offset
      })
    }
    _vars.scrollOffsetApplied = true
    window.scrollTo(0, 0)

    ENV.BODY.addClass('nav-open')
    ENV.BODY.removeClass('nav-close')
  }, 10)

  // _vars.backdrop = ($('.modal-backdrop-for-header').length == 0) ? $(document.createElement('div')).addClass('modal-backdrop-for-header modal-backdrop in ' + _vars.animate).appendTo(ENV.BODY) : $('.modal-backdrop-for-header').fadeIn()

  _setElements()

  // $el.modalBackdrop.on('click', function (e) {
  //   e.preventDefault()

  //   if (_vars.isOpen) {
  //     _close()
  //   }
  // })
}

const _close = function () {
  _vars.isOpen = false

  ENV.BODY.addClass('nav-close')
  ENV.BODY.removeClass('nav-open')

  // // Remove Fuax scroll offset and restore real offset
  // $el.wrap.attr('style', '')
  // window.scrollTo(0, _vars.scrollPos)
  // _vars.scrollOffsetApplied = false

  $el.nav.attr('aria-hidden', true)

  // UPDATE MENU BUTTON
  $el.menuBtn.attr('aria-expanded', false)
  $el.menuBtn.removeClass('toggled')
  // MENU_BUTTON.change(_vars.isOpen)

  // Remove the height so that the pages content can be clicked
  $el.nav.attr('style', '')
  // _vars.backdrop.fadeOut()

// Remove class cause ie9 & 8 don't remove the class and causes layout issues
// if (ENV.HTML.hasClass('lt-ie10')) $('body').removeClass('nav-close')
}

const LANGUAGE_BUTTON = {
  init: function () {
    this.change()

    this.searchPopup()
  },

  change: function () {
    $el.languageBtn.on('click', function (e) {
      e.preventDefault()
      if (!isMobile) {
        if ($(this).hasClass('open')) {
          $el.nav.css('overflow', 'hidden')
        } else {
          $el.nav.css('overflow', 'auto')
        }
      }
    })
  },

  searchPopup: function () {
    $('#search-modal').on('shown.bs.modal', function (e) {
      // do something...
      $('input.shenyun-top-search-form-input').focus()
    })
  }

}

const _scroll = () => {
  const scrollPos = $(document).scrollTop()

  if (_vars.isOpen || ENV.BODY.hasClass('lock')) return false
//
// if (scrollPos > 100) {
//     ENV.BODY.removeClass('vertical-head')
// } else {
//     ENV.BODY.addClass('vertical-head')
// }
}

// Where cached elements are stored.
let $el = {}

// Set/Reset and Cache Module elements
const _setElements = function () {
  // Cache Elements into $el
  $.each(_selectors, function (i, obj) {
    $el[i] = $(obj)
  })
}

// Modules Predfined and passed options
const _options = {
  navClass: '',
  onCompleteFunc: function () {}
}

// ajax().then(res => {
// }).catch(err => {})

_init()

const Navigation = {
  _detectToClosedMenu: function () {
    _detectToClosedMenu()
  }
}

export default Navigation
